import type { ReactElement, ReactNode } from 'react';
import { useT } from '../../../../app/di';
import styles from './AuthLayout.module.scss';

/** Страница до входа: свой фон, логотип и узкая колонка карточек (вход, демо, настройки). */
export function AuthLayout({ children }: { children: ReactNode }): ReactElement {
  const { t } = useT();
  return (
    <main className={styles.page}>
      <div className={styles.column}>
        <div className={styles.brand}>
          <span className={styles.logo} aria-hidden="true">
            GR
          </span>
          <div>
            <h1 className={styles.title}>{t('common.appName')}</h1>
            <p className="u-muted">{t('identity.login.subtitle')}</p>
          </div>
        </div>
        {children}
      </div>
    </main>
  );
}
